import ReactSelect from 'components/common/react-select/ReactSelect';
import React from 'react';
import { IFilterColumn } from 'components/report-content/components/manage-filters/index';
import { Box } from '@mui/material';

export function prepareSelectFilterData(filter: IFilterColumn, addEmptyOption: boolean = true) {
    if (!Array.isArray(filter.data)) {
        return { data: [], values: [] };
    }
    const decodeHtml = (str: string): string => {
        const txt = document.createElement('textarea');
        txt.innerHTML = str;
        return txt.value;
    };

    const data = filter.data.map((el: any) => {
        const raw =
            'undefined' !== typeof el[filter.uid + '-formatted'] ? el[filter.uid + '-formatted'] : el[filter.uid];
        return {
            value: el[filter.uid],
            label: typeof raw === 'string' ? decodeHtml(raw) : raw,
        };
    });

    let values = filter.savedValues;
    if (
        filter.savedValues &&
        filter.savedValues.length > 0 &&
        filter?.use_external_filter_value == 'Y' &&
        filter?.external_delimiter &&
        filter?.external_delimiter > ''
    ) {
        for (let i = 0; i < values.length; i++) {
            let cmp = values[i].trim().toLowerCase();
            for (let j = 0; j < data.length; j++) {
                if (data[j].label.toLowerCase() == cmp) {
                    values[i] = data[j].value;
                }
            }
        }
    }

    if (filter.filterType == 'dropdown') {
        if (filter.include_all_value == 'Y') {
            if (addEmptyOption) {
                data.unshift({ value: '', label: 'All' });
            }
            if (filter.savedValues.length == 0) {
                values = [''];
            }
        } else {
            if (filter.savedValues.length == 0 && data.length) {
                values = data[0].value;
            }
        }
    }
    return { data, values };
}

export default function FilterControlSelect({
    filter,
    onChange,
}: {
    filter: IFilterColumn;
    onChange: (newValue: any) => void;
}) {
    // Prepare Data object for Select2
    const { data, values } = prepareSelectFilterData(filter);
    if (
        filter.filterType == 'dropdown' &&
        filter.include_all_value != 'Y' &&
        filter.savedValues.length == 0 &&
        data.length
    ) {
        onChange(data[0].value);
    }

    return (
        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
            <ReactSelect
                dataTest={`filter-${filter.column_name}`}
                placeholder={'All'}
                isMulti={filter.filterType == 'multiselect'}
                isMultiOneRowMode={filter.filterType == 'multiselect'}
                data={data}
                update={onChange}
                value={values}
            />
        </Box>
    );
}
